export const productsUnavailableEnum = {
  BALCAO: 1,
  AA: 2,
  DELIVERY: 3
};
